// FOLDY LAYOUT
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@QUJ=!^zs|!LwN@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@Dz~`     .;r,`_\D@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@#o!'           ,^;`,|K@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@K\~`               .;!',|K@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@#y!'                     :!:,*A@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@dT~`                         ';~~?q@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@Qm^'                              `:~~<U@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@gn;`                                   '~;*6@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@q|,                                        `,;*U@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@Qm^'                    '~                       '~?XQ@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@Qy;`  rSRWDZL,            q@I                        `~|U@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@NI~`  =Q@y!~!zkJ            `W@o`                         ,*X@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@Ns~`   j@N'                     t@Qn~        ,?7`             '=jdQ@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@8t;`    }@D`                       `*AQ@Q%bdWQ@Qdz`              `.'~^J6#@@@@@@@@@@@@@@@@@@
// @@@@@@@#n;``    '@@.                            '~!rr!~.                  ````.`'~!zUN@@@@@@@@@@@@@@
// @@@@@#n;`````   !@Q                                                      `.````````.':;LEgQ@@@@@@@@@
// @@@Bu;````````   ^:               ~!`               ;#Q7                 `.`````````````.,;?SRQ@@@@@
// @Qo!.`````````                   ~@@@,              #@@@_               `.``````````````````.,;|E8@@
// NL'````````````                  ;@@@j              6@@@X               ````````````````````````.~Lg
// z,`````````````                   W@@g              `d@@y              ```````````````````````````~z
// s_``````````````                  `UQ*                `.              ````````````````````````````~7
// m;``````````````                                                      `.``````````````````````````!5
// g?```````````````                                                    ````````````````````````````.|g
// @7'```````````````                                                   ````````````````````````````:7@
// @k^```````````````                                    .*}'          `````````````````````````````+X@
// @@v'```````````````               ;~              ,+y#@BI`         `````````````````````````````,TQ@
// @@q=````````````````             `U@@DS}tttsuyEbB@@g5<'            `````````````````````````````^w@@
// @@@J,```````````````                ,!|7Ijjjs7?^_`                `````````````````````````````'\Q@@
// @@@g?````````````````                                            `.````````````````````````````!Z@@@
// @@@@j;````````````````                                           ````````````````````````````.,TQ@@@
// @@@@@f;'.``````````````                                        ```````````..```.`..........',~LW@@@@
// @@@@@@QgdAUEajIz\L*=^!;;;~~~~~~~~~~~~;;;;;;;;;;;;;;!!^^^^^r++<|i\T7zJtsn}fjjyyy5ZmmwwEEEhkUqDN@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// https://objectshowfanonpedia.fandom.com/wiki/Foldy

import * as React from 'react'
import {useContext, useState, createContext, useEffect, useMemo} from 'react'
import classnames from 'classnames'
import { Link } from 'react-router-dom'
import {useObserver} from "mobx-react";
import {AppNavigatorContext} from "../navigator/AppNavigator";
import {useNavPreferences} from "../../../uiMigration/navPreferences";
import RegisterPortal from '../../../components/portals/RegisterPortal';
import { FILTER_TOGGLE, PAGE_FILTERS } from "../navigator/navigatorPortalNames";
import { PageFiltersContext } from './PageFilters';
import VerticalPageFiltersLayout from './VerticalPageFiltersLayout';
import { renderNav, NavItem } from "./NavRenderingUtils";
import PageHeaderLayout from './PageHeaderLayout';
import Button from '../../../components/buttons/Button';
import { CSSTransition } from 'react-transition-group';
import variables from "../../../../src/components/bootstrap4/includes/_core-variables.scss"
import UsePageTitle from './UsePageTitle';
import PageTitle from '../../../components/typography/PageTitle';
import { HelpIcon } from '../../../components';
import HeaderHelpCenterButton from "./HeaderHelpCenterButton";
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import {NotificationList} from "../../../services/notifications/NotificationList";

export function FoldyLayout({
     children,
     className
}) {
  const prefs = useObserver(() => useNavPreferences());
  const navigationContext = useContext(AppNavigatorContext);
  const {
    setFiltersOpen,
    isFiltersOpen,
    setHasFilters,
    hasFilters
  } = useContext(FoldyContext);

  useEffect(() => {
    // prevents a show filter bug that occurs when going to another sitemap in desktop width, then resizing to mobile then returning to first sitemap page
    if(window.innerWidth <= 768) {
      setFiltersOpen(false);
    }
    // start with a blank slate
    setHasFilters(false);
    if(window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(() => {
        document.querySelector(".foldy").style.setProperty('--scrollbar-width', `${window.innerWidth - document.documentElement.clientWidth}px`);
      });
      resizeObserver.observe(document.body);
      return () => resizeObserver.unobserve(document.body);
    }
  }, []);

  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const transitionDuration = parseInt(variables.transitionDuration);

  function renderContent() {
    return <div id="contentArea" className={`card-spacer-padding-left card-spacer-padding-right content-area card-spacer-top content-area-bottom-spacer ${hasFilters ? "has-filters" : ""}`}>
      { children }
    </div>
  }

  function renderPills() {
    if (!navigationContext.navL3.length) {
      return null
    } else {
      return <nav className="nav nav-pills cursor-default level-3-tabs card-spacer-padding-left card-spacer-padding-right card-spacer-top">
        <div className="d-flex flex-row scroll-container position-relative floating-tabs">
          {
            navigationContext.navL3.map(({path, title, eventName, active, icon, exact}) => {
              return <NavItem containerClassName="scroll-tab" path={path} key={path} active={active} eventName={eventName} exact={exact}>{title}</NavItem>
            })
          }
        </div>
      </nav>;
    }
  }
  return (
      <PageFiltersContext.Provider value={{
        PageFiltersLayout: VerticalPageFiltersLayout
      }}>
        <div
          className={classnames(
            "main-container d-flex flex-column fill-height",
            className,
            prefs.rebrandClass
          )}
        >
          <div className="d-flex align-items-center w-100 foldy-layout-main-header-top-wrapper sticky-top">
            <div className="main-header-top foldy-layout-main-header-top d-flex flex-column align-items-center w-100">
              <div className="container-fluid d-flex align-items-center">
                {!prefs.hideLogo && (
                  <span className="my-2" style={{
                    height: "39px"
                  }}>
                    <Link to="/" className="logo" title="home">
                      <img
                        className="navbar-brand-logo"
                        src={prefs.logoUrl}
                        alt="logo"
                      />
                    </Link>
                  </span>
                )}
                <div className="d-flex align-items-center ml-auto">
                  {!prefs.hideHelpCenter && <div className="header-button">
                    <HeaderHelpCenterButton />
                  </div>}
                  {!prefs.hideWorkflow2 && (
                    <div className="header-button">
                      <NotificationList foldyLayout />
                    </div>
                  )}
                  <UncontrolledDropdown className="p-0 bg-transparent list-unstyled text-decoration-none">
                    <DropdownToggle caret={false} className="fas fa-user-circle header-button p-0 m-0 border-0 text-decoration-none" />
                    <DropdownMenu right className="top-nav-settings-dropdown">
                      <DropdownItem disabled className="pt-0 text-body">
                        {`${prefs.userFirstName}`}
                      </DropdownItem>
                      <DropdownItem divider className="m-0" />
                      <DropdownItem href="#/admin/v2/user" onClick={() => {
                        if(navigationContext.siteMapId === 0){
                          navigationContext.setPreviousPrimarySitemapLocation(navigationContext.location.pathname)
                        }
                      }}>
                        <div className="d-flex flex-row algin-items-center">
                          <i className="fas fa-cog d-flex align-items-center content-spacer-right"></i> Settings
                        </div>
                      </DropdownItem>
                      <DropdownItem divider className="m-0" />
                      <DropdownItem href="#/user/logout">
                        <div className="d-flex flex-row algin-items-center">
                          <i className="fas fa-sign-out-alt d-flex align-items-center content-spacer-right"></i> Log Out
                        </div>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column flex-1">
            <div className="d-flex flex-1">
              <div className="d-flex flex-1 flex-column flex-md-row foldy-layout">
                <div className="sticky-top sticky-nav-wrapper">
                  <CSSTransition in={mobileNavOpen} timeout={transitionDuration} classNames="foldy-mobile-nav">
                    <div className="sticky-top foldy-nav-wrapper h-100">
                      <div className="foldy-nav h-100">
                        <nav className="nav nav-pills nav-stacked d-flex flex-column flex-1 tabs-area cursor-default foldy-nav-inner">
                          <div className="d-flex flex-row justify-content-between align-items-center">
                            { navigationContext.isDrillInSiteMap && <div className="d-flex flex-row align-items-center"><Link to={navigationContext.previousPrimarySitemapLocation} className="align-items-center text-light">
                                <Button
                                  color="link"
                                  icon="fas fa-arrow-left"
                                  className="text-decoration-none text-body pr-1"
                                  style={{
                                    fontSize: "1.2rem"
                                  }}
                                />
                              </Link>
                              <div className="mr-auto" style={{
                                fontWeight: "bold",
                                fontSize: "1.2rem"
                              }}>{ navigationContext.siteMapTitle }</div>
                              </div>
                            }
                            <Button
                              color="link"
                              className="mobile-nav-close-button ml-auto text-decoration-none text-body"
                              onClick={() => setMobileNavOpen(false)}
                            >
                              Close
                            </Button>
                          </div>
                          <div className={`${navigationContext.isDrillInSiteMap ? "" : "my-3"}`}>
                            { renderNav(navigationContext) }
                          </div>
                        </nav>
                      </div>
                    </div>
                  </CSSTransition>
                </div>
                <div className="d-flex flex-column flex-1">
                  <div className="d-flex flex-row flex-wrap align-items-center card-spacer-padding sticky-page-header-wrapper">
                    <div className="d-flex flex-column flex-row flex-1">
                      <div className="d-flex flex-row align-items-center flex-1">
                        <div className="mobile-nav-toggle floating-commands">
                          <Button
                            color="link"
                            icon="fas fa-bars"
                            className="card-spacer-right"
                            aria-label="Open Nav"
                            onClick={() => setMobileNavOpen(true)}
                          />
                        </div>
                        <PageHeaderLayout />
                        {
                          !navigationContext.activeNode.hasPageTitleOverride && <UsePageTitle>
                            <div className="d-flex flex-row align-items-center">
                              <PageTitle>
                                {navigationContext.activeNode.title}
                              </PageTitle>
                                {navigationContext.activeNode.helpIconMessage ? <HelpIcon style={{textAlign: "left"}} message={navigationContext.activeNode.helpIconMessage}/> : null}
                            </div>
                          </UsePageTitle>
                        }
                        <div className="ml-auto">
                          {/* Toggle will only show up when RenderToPortal is rendered in the filter component */}
                          <RegisterPortal
                            id={FILTER_TOGGLE}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-row flex-1">
                    <div className="d-flex flex-column flex-1">
                      {renderPills()}
                      {
                        !hasFilters
                        ? renderContent()
                        : <PreExitedCSSTransition in={isFiltersOpen} timeout={transitionDuration} classNames="width-container">
                            { renderContent() }
                          </PreExitedCSSTransition>
                      }
                    </div>
                  </div>
                </div>
                <div className="sticky-top sticky-filter-wrapper">
                  { !hasFilters /** PageFiltersLayout behavior is to render the portal inline. Render to a black hole until hasFilters */
                  ? <RegisterPortal className="d-none" id={PAGE_FILTERS} tagProps={{
                      className: `vertical-filter-grid flex-column filters-area rounded-0`
                    }} />
                  : <PreExitedCSSTransition in={isFiltersOpen} timeout={transitionDuration} classNames="foldy-filters">
                    <div className="sticky-top filters-wrapper">
                      <RegisterPortal id={PAGE_FILTERS} tagProps={{
                        className: `vertical-filter-grid flex-column filters-area rounded-0`
                      }} />
                    </div>
                    </PreExitedCSSTransition> }
                </div>

                {/* The sidebar overlays were getting too coupled, simplify for future-proofing */}
                {/* Mobile nav overlay */}
                <PreExitedCSSTransition in={mobileNavOpen} timeout={transitionDuration} classNames="mobile-nav-overlay">
                  <div
                    className="transparent-overlay cursor-pointer"
                    onClick={() => {
                      //Close if background is clicked.
                      setMobileNavOpen(false);
                    }}
                  ></div>
                </PreExitedCSSTransition>

                {/* Mobile filters overlay */}
                <PreExitedCSSTransition in={isFiltersOpen && hasFilters} timeout={transitionDuration} classNames="mobile-filter-overlay">
                  <div
                    className="transparent-overlay cursor-pointer"
                    onClick={() => {
                      //Close if background is clicked.
                      setFiltersOpen(false);
                    }}
                  ></div>
                </PreExitedCSSTransition>
              </div>
            </div>
          </div>
        </div>
      </PageFiltersContext.Provider>
  );
}
/**
 * Decorator for CSSTransition that slightly modifies initial appearance behavior
 * workaround for http://reactcommunity.org/react-transition-group/css-transition
 *
 * > If the transition component mounts with in={false}, no classes are applied
 * > yet. You might be expecting *-exit-done, but if you think about it, a
 * > component cannot finish exiting if it hasn't entered yet.
 *
 * The above behavior is difficult to work with if the component has a variable initial state.
 * - adds the "appear" prop to true if the component is initially not in
 * - adds an "exit-done" class if the component until the component is first "in"
 *
 *
 * */
function PreExitedCSSTransition (props) {
  const [classes, setClasses] = useState(() => props.in ? [props.classNames + "-enter-done"] : [props.classNames + "-exit-done"]);
  const onEntering = () => setClasses([props.classNames + "-enter"])
  const onEntered = () => setClasses([props.classNames + "-enter-done"])
  const onlyChild = React.Children.only(props.children);

  return <CSSTransition  {...props} onEnter={onEntering} onEntered={onEntered} >{
    React.cloneElement(onlyChild, { className: [onlyChild.props.className].concat(classes).join(" ") })
  }</CSSTransition>;

}

export const FoldyContext = createContext({
  setFiltersOpen: () => {},
  isFiltersOpen: false,
  setHasFilters: () => {},
  hasFilters: false
});

export const FoldyContextProvider = ({
  children
}) => {
  const [isFiltersOpen, setFiltersOpen] = useState(() => window.innerWidth > 768);
  const [hasFilters, setHasFilters] = useState(false);

  useEffect(() => {
    // Body class To handle tooltips/etc
    window.document.body.classList.add("foldy");
    
    // Safari-only namespace for sticky scrolling quirk (affects filters container)
    // Cool guy Chrome has both "Safari" and "Chrome" in its UA string :(
    const isChrome = navigator.userAgent.indexOf('Chrome') > -1;
    const isSafari = navigator.userAgent.indexOf("Safari") > -1;
    if (!isChrome && isSafari) { 
      window.document.body.classList.add("is-safari");
    }

    return () => {
      window.document.body.classList.remove("foldy");
      window.document.body.classList.remove("is-safari");
    };
  }, []);

  return <FoldyContext.Provider
    value={{
      setFiltersOpen,
      isFiltersOpen,
      setHasFilters,
      hasFilters
    }}
  >{children}</FoldyContext.Provider>
}
